/** Only source-owned header variants; content is plain text and colors are bounded hex values. */
export type BrandDecoration={
 kind:'watermark'|'profile'|'cinematic';
 scale:number;canvasWidth:number;backgroundHeight:number;hidden:boolean;
 title:string;emoji:string;subtitle:string;titleSize:number;titleColor:string;
 highlight:string|null;background:string|null;divider:string|null;avatarColor:string;
};
export function validBrandDecoration(value:unknown):value is BrandDecoration{
 if(!value||typeof value!=='object'||Array.isArray(value))return false;
 const d=value as BrandDecoration;
 const color=(v:unknown)=>typeof v==='string'&&/^#(?:[0-9a-f]{3}|[0-9a-f]{4}|[0-9a-f]{6}|[0-9a-f]{8})$/i.test(v);
 const n=(v:unknown,min:number,max:number)=>typeof v==='number'&&Number.isFinite(v)&&v>=min&&v<=max;
 return ['watermark','profile','cinematic'].includes(d.kind)&&n(d.scale,1/1920,32)&&n(d.canvasWidth,16,7680)&&n(d.backgroundHeight,0,15360)&&typeof d.hidden==='boolean'
  &&typeof d.title==='string'&&d.title.length<=120&&typeof d.emoji==='string'&&d.emoji.length<=64&&typeof d.subtitle==='string'&&d.subtitle.length<=160
  &&n(d.titleSize,Number.MIN_VALUE,2000)&&color(d.titleColor)&&color(d.avatarColor)
  &&[d.highlight,d.background,d.divider].every(c=>c===null||color(c));
}
